module.exports = __webpack_public_path__ + "static/media/source-sans-pro-semibolditalic.6b058fc2.woff";